import { keyframes, css } from "styled-components";
const whiteBgOnClick = keyframes`
/* 0.500s */
    0% {
        opacity: 0;
    }
    33% {
        opacity: 0.5;
        animation-timing-function: cubic-bezier(0.17,0.17,0.2,1);
    }
    100% {
        opacity: 0;
        animation-timing-function: cubic-bezier(0.17,0.33,0.2,1);
    }
`;
const scaleOnClick = keyframes`
/* 0.333s */
    0% {
        transform: rotate(0deg) scale(1);
    }
    50% {
        transform: rotate(0deg) scale(0.65);
        animation-timing-function: cubic-bezier(0.33,0,0,1);
    }
    100% {
        transform: rotate(0deg) scale(1);
        animation-timing-function: cubic-bezier(0,0,0,1);
    }
`;

const textClick = keyframes`
/* 0.500s */
    0% {
        opacity: 1;
    }
    33%{
        opacity: 0.5;
        animation-timing-function: cubic-bezier(0.17,0.17,0.2,1);
    }
    100% {
        opacity: 1;
        animation-timing-function: cubic-bezier(0.17, -0.33, 0.2, 1);
    }
`;

export const textClickAnim = css`
  ${textClick}
`;
export const whiteBgOnClickAnim = css`
  ${whiteBgOnClick}
`;
export const scaleOnClickAnim = css`
  ${scaleOnClick}
`;

const rowFadeOut = keyframes`
  0% {
      opacity: 1;
  }
  100% {
      opacity: 0;
      animation-timing-function: cubic-bezier(0.5, 0, 0, 1);
  }
`;
const textApear = keyframes`
    0% {
      transform: translateY(16px);
      opacity: 0;
    }
    36% {
      animation-timing-function: cubic-bezier(0.5, 0, 0, 1);
      opacity: 1;
    }
    100% {
      opacity: 1;
      transform: translateY(0px);
      animation-timing-function: cubic-bezier(0.17, 0.17, 0, 1);
    }
`;
const fadeIn = keyframes`
/* 0.167s */
  0%{
     opacity:0;
    transition-timing-function: cubic-bezier(0.17, 0.17, 0, 1);
  }
  100%{
    opacity:1;
   } 
`;

const fadeOut = keyframes`
/* 0.167s */

  0%{
    opacity:1;
    transition-timing-function: cubic-bezier(0.17, 0.17, 0, 1);
    }
  100%{
    opacity:0;
   } 
`;
const boxIn = keyframes`
/* 0.500 */
 0% {
   transform: translateY(65px);
   animation-timing-function: cubic-bezier(0.42, 0, 0.07, 0.9);
 }
 50% {
  transform:  translateY(-15px);
  animation-timing-function: cubic-bezier(0.29, 0.2, 0.62, 1);
 }
 100% {
   transform:  translateY(0px);
 }
`;

const boxOut = keyframes`
/* 0.550 */
 0% {
   transform: translateY(0px);
  animation-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
 }
 100% {
   transform: translateY(150px);
 }
`;
const btnRotate = keyframes`
  0% {
    transform:  rotate(-45deg);
    animation-timing-function: cubic-bezier(0.25, 0.2, 0.1, 0.9);
  }
  33% {
    transform: rotate(13.34deg);
    animation-timing-function: cubic-bezier(0.25, 1, 0.75, 0.1);
  }
  66% {
    transform: rotate(-10.65deg);
    animation-timing-function: cubic-bezier(0.25, 0, 0.75,1);
  }
  100% {
    transform: rotate(0deg);
  }
`;
export const btnRotateAnim = css`
  ${btnRotate}
`;
export const fadeInAnim = css`
  ${fadeIn}
`;
export const fadeOutAnim = css`
  ${fadeOut}
`;
export const boxInAnim = css`
  ${boxIn}
`;
export const boxOutAnim = css`
  ${boxOut}
`;
export const textApearAnim = css`
  ${textApear}
`;

export const rowFadeOutAnim = css`
  ${rowFadeOut}
`;
